import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Image from 'react-bootstrap/Image';
import Footer from '../LayOut/Footer';
import Header from '../LayOut/Header';
import Instagram from '../../images/instagram.png';
import Facebook from '../../images/facebook.png';
import Whatsapp from '../../images/whatsapp.png';

const imageStyle = { height: '30vh', maxWidth: '100%' };

const line = {
	height: '39px',
	borderBottom: '2px solid lightgray',
  }
  
const triangle = {
	background: 'white',
	border: '2px solid lightgray',
	borderWidth: '2px 2px 0 0',
	transform: 'rotate(-43deg)',
	position: 'relative',
	top: '23px',
	width: '2px',
	height: '29px',
}

class AboutUs extends React.Component {
	
	render() {
		const { instagram, facebook, whatsapp } = this.props;
		const url_ = "https://wa.me/".concat('+').concat(whatsapp).concat('?text=').concat('')
    const instagramUrl = 'https://www.instagram.com/'.concat(instagram)
    
		return (
			<Fragment>
				<Header/>
				<div className="col-md-3 offset-md-4 pl-0 pr-0 mt-0" style={{ marginBottom: '80px' }}>
			
					<div className="container mt-0 pt-0">
						<div className="row justify-content-center mt-0">
							<Image src={this.props.urlPortada} style={imageStyle} />
						</div>

						<div
							className="row justify-content-center mt-3"
							style={{ fontWeight: 'bold', fontSize: 17, fontFamily: 'Helvetica' }}
						>
							Descripción de la empresa
						</div>
						
						<div className="row mt-1 ml-1 mr-1" style={{ fontFamily: 'Helvetica' }}>
							{this.props.description}
						</div>
						

						<div className="container" style={line}>
							<div className="container mr-0 ml-0" style={triangle}/>
						</div>
						
						{whatsapp !== '' ? (
              <div className="row align-items-center">
                <div className="col-3">
                  <Image src={Whatsapp} style={{width: '100%'}} />
                </div>
                <div className="col-9">
                  <a style={{color: 'black'}} target="_blank" rel="noopener noreferrer" href={url_} > +{whatsapp} </a>
                </div>
              </div>
              ) : (
                ''
            )}

						{instagram !== '' ? (
              <div className="row align-items-center">
                <div className="col-3">
                  <Image src={Instagram} style={{width: '100%'}} />
                </div>
                <div className="col-9">
                  <a style={{color: 'black'}} target="_blank" rel="noopener noreferrer" href={instagramUrl} >{instagram}</a>
                </div>	
              </div>
              ) : (
                ''
						)}

						{facebook !== '' ? (
              <div className="row align-items-center">
                <div className="col-3">
                  <Image src={Facebook} style={{width: '100%'}} />
                </div>
                <div className="col-9">
                  <a style={{color: 'black'}} target="_blank" rel="noopener noreferrer" href={url_} >{facebook}</a>
                </div>	
              </div>
              ) : (
                ''
						)}

					</div>
				</div>
				<Footer />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	description: state.description,
	urlPortada: state.urlPortada,
	whatsapp: state.whatsapp,
	instagram: state.instagram,
	facebook: state.facebook
});

export default connect(mapStateToProps, {})(AboutUs);
